module.exports = __webpack_public_path__ + "static/img/home_showmore_photo5@2x.d872d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_showmore_photo5@2x.png
// module id = l0fR
// module chunks = 0